import { COMPANY_PREFIX, COMPANY_TYPE } from '../constants/company';
import { isMetisStudent } from '../utils/common';
import { getCurCompany } from '../utils/company';
var _productId = isMetisStudent ? '21000036' : '21000037';
var origin = 'https://login.feixiangxingqiu.biz';
var feixiangLaoshiOrigin = 'https://login.feixianglaoshi.biz';
var company = getCurCompany();
var prefix = COMPANY_PREFIX[company];
var defaultRedirect = 'https://laoshi.feixiangxingqiu.biz';
switch (company) {
  case COMPANY_TYPE.HSMSF:
    defaultRedirect = 'https://laoshi.feixiangxingqiu.biz/hsmsf';
    break;
  case COMPANY_TYPE.PGQJYWYH:
    defaultRedirect = 'https://laoshi.feixiangxingqiu.biz/pgqjywyh';
    break;
  case COMPANY_TYPE.FEIXIANG:
    defaultRedirect = 'https://laoshi.feixiangxingqiu.biz';
    break;
  case COMPANY_TYPE.JIANGUAN:
    defaultRedirect = 'https://jianguan.feixiangxingqiu.biz';
    break;
  case COMPANY_TYPE.FLYING:
    defaultRedirect = 'https://shouji.feixiangxingqiu.biz';
    break;
  case COMPANY_TYPE.WX_MOBILE:
    defaultRedirect = 'https://ke.feixiangxingqiu.biz/suicai/#/logistics-list';
    break;
  case COMPANY_TYPE.SUZHOUYIJIAXUEYUAN:
    defaultRedirect = 'https://laoshi.feixiangxingqiu.biz/szyjxy/#/thoth/home';
    break;
}
var feixiangxingqiu = {
  HTTP_BASE_URL: 'https://mapi.feixiangxingqiu.biz',
  // HTTP_BASE_URL: 'https://app-update--mapi.test-venv.feixiangxingqiu.biz',
  AVATAR_PREFIX: 'https://metis-test.fbcontent.cn/metis-account/metis-avatar/',
  lectioHome: 'https://ke.feixiangxingqiu.biz/#/lesson',
  resetPsdURL: "".concat(origin).concat(prefix, "/#/embed/reset-password"),
  defaultRedirect: defaultRedirect,
  defaultRedirectStudent: 'https://xuesheng.feixiangxingqiu.biz',
  loginURL: "".concat(origin).concat(prefix, "/#/login"),
  designationLoginURL: "".concat(origin).concat(prefix, "/#/designation-login"),
  designationStudentLoginURL: "".concat(origin).concat(prefix, "/#/designation-student-login"),
  openLoginURL: "".concat(origin).concat(prefix, "/#/open-login"),
  chooseURL: "".concat(origin).concat(prefix, "/#/embed/choose"),
  perfectURL: "".concat(origin).concat(prefix, "/#/embed/info"),
  noPermissionUrl: "".concat(origin).concat(prefix, "/#/embed/403"),
  WX_SCAN_REDIRECT_location: 'https://mapi-pub.feixiangxingqiu.biz',
  WX_SCAN_REDIRECT_URL: 'https://mapi-pub.feixiangxingqiu.biz/metis-weixin/api/ws/wx3b0eb1b52d6fb874/oauth-forward',
  WX_SCAN_APPID: 'wx3b0eb1b52d6fb874',
  WX_SCAN_REDIRECT_BACK_URL: "".concat(origin).concat(prefix, "/#/embed/personal-data"),
  teacherTemplate: 'https://metis-online.fbcontent.cn/metis-lectio/kBH613TBliaaKZMIFcty.xlsx',
  loginDomain: '.feixiangxingqiu.biz',
  // WX_SCAN_REDIRECT_BACK_URL: 'https://local.feixiangxingqiu.biz:3000//#/embed/personal-data',
  _productId: _productId
};
var feixianglaoshi = {
  HTTP_BASE_URL: 'https://mapi.feixianglaoshi.biz',
  // HTTP_BASE_URL: 'https://app-update--mapi.test-venv.feixianglaoshi.biz',
  AVATAR_PREFIX: 'https://metis-test.fbcontent.cn/metis-account/metis-avatar/',
  lectioHome: 'https://ke.feixianglaoshi.biz/#/lesson',
  resetPsdURL: "".concat(feixiangLaoshiOrigin, "/#/embed/reset-password"),
  defaultRedirect: 'https://pro.feixianglaoshi.biz',
  defaultRedirectStudent: 'https://pro.feixianglaoshi.biz',
  loginURL: "".concat(feixiangLaoshiOrigin, "/#/login"),
  designationLoginURL: "".concat(feixiangLaoshiOrigin, "/#/designation-login"),
  designationStudentLoginURL: "".concat(feixiangLaoshiOrigin, "/#/designation-student-login"),
  openLoginURL: "".concat(feixiangLaoshiOrigin, "/#/open-login"),
  chooseURL: "".concat(feixiangLaoshiOrigin, "/#/embed/choose"),
  perfectURL: "".concat(feixiangLaoshiOrigin, "/#/embed/info"),
  noPermissionUrl: "".concat(feixiangLaoshiOrigin, "/#/embed/403"),
  WX_SCAN_REDIRECT_location: 'https://mapi-pub.feixianglaoshi.biz',
  WX_SCAN_REDIRECT_URL: 'https://mapi-pub.feixianglaoshi.biz/metis-weixin/api/ws/wx3b0eb1b52d6fb874/oauth-forward',
  WX_SCAN_APPID: 'wx3b0eb1b52d6fb874',
  WX_SCAN_REDIRECT_BACK_URL: "".concat(feixiangLaoshiOrigin, "/#/embed/personal-data"),
  teacherTemplate: 'https://metis-online.fbcontent.cn/metis-lectio/kBH613TBliaaKZMIFcty.xlsx',
  loginDomain: '.feixianglaoshi.biz',
  // WX_SCAN_REDIRECT_BACK_URL: 'https://local.feixianglaoshi.biz:3000//#/embed/personal-data',
  _productId: _productId
};
var config = {
  feixiangxingqiu: feixiangxingqiu,
  feixianglaoshi: feixianglaoshi
};
export default config;